import React, { Component, Fragment } from 'react';
import List from './list';
import Styles from './styles/linkStyles';
import './styles/linkStyles.css';

class Link extends Component {
  render() {
    const { link, showMenu } = this.props;
    return (
      <Fragment>
        {link.links
          ?<li className="menu__item" style={{borderBottom:"0px solid #ccc",...Styles.liStyle}}>
            <button className={this.props.className + ' accordion closed'} tabIndex="-1" onClick={showMenu} style={{...Styles.buttonStyle, ...this.props.styles}}>{link.title}</button>
            <List level={this.props.level} links={link.links} className="panel closed" styles={{margin:"0 0 8px",padding:"0"}} showMenu={this.props.showMenu} />
          </li>
          :<li className="menu__item" style={{...Styles.liStyle}}><a tabIndex="-1" className={this.props.className} style={{...Styles.linkStyle, ...this.props.styles}} href={link.uri}>{link.title}</a></li>}
      </Fragment>
    );
  }
}

export default Link;
